import React, { FC, useState } from 'react'

import cn from 'classnames'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

import { Popover, List, ListItem } from '@material-ui/core'
import { ExpandMore } from '@material-ui/icons'

import { Flexbox, NavLink, Text } from '~/components/shared'

import { AppState } from '~/state/store'

import { useHeaderListArray } from './HeaderList.config'
import { useHeaderPopoverStyles } from './HeaderPopover.styles'

const scope = 'components.layouts.Header.HeaderPopover'

const HeaderPopover: FC<HeaderProps> = ({ logout }) => {
  const s = useHeaderPopoverStyles()

  const HeaderListArray = useHeaderListArray()

  const name = useSelector((state: AppState) => state.user.name)

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (): void => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  return (
    <div>
      <Flexbox
        className={cn(s.btn, {
          active: open
        })}
        onClick={handleClick}
      >
        <Text color="textPrimary">{name}</Text>
        <ExpandMore className="arrow" />
      </Flexbox>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={{ top: 60, left: 30 }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
      >
        <List className={s.container} disablePadding>
          {HeaderListArray.map(({ label, value }) => (
            <ListItem key={value} disableGutters>
              <NavLink href={value}>
                <Text>{label}</Text>
              </NavLink>
            </ListItem>
          ))}

          <ListItem disableGutters onClick={logout}>
            <Text>
              <FormattedMessage
                id={`${scope}.logout`}
                defaultMessage="Logout"
              />
            </Text>
          </ListItem>
        </List>
      </Popover>
    </div>
  )
}

export default HeaderPopover
